module.exports = __webpack_public_path__ + "images/services/google-g-logo.2ccbebadc7891e8f0896.svg";